/* eslint-disable max-len */
const exports =
	`
	{{? SETUPS.get('nemo.footnote-engine.active') === true}}
		{{? !SETUPS.get('scopes.nemo.DISABLE_FEATURE_HUB') && SETUPS.get('scopes.nemo.ONEFOOTER_FA_INCLUDE') && SETUPS.get('nemo.fefa.scOneFootnoteJsonUrl') && SETUPS.get('nemo.FefaFeatureAppVersion')}}
			<feature-app id="audi-footnote-engine-layer-` +
	Math.floor(Math.random() * 1000000) +
	`" src="https://featureapps.audi.com/audi-feature-app-footnote-engine/{{=SETUPS.get('nemo.FefaFeatureAppVersion')}}/audi-footnote-engine.umd.js" config='{"apiUrls": ["{{=SETUPS.get('nemo.fefa.scOneFootnoteJsonUrl')}}"] }' css='[{"href": "https://featureapps.audi.com/audi-feature-app-footnote-engine/{{=SETUPS.get('nemo.FefaFeatureAppVersion')}}/audi-footnote-engine.css"}, {"href": "https://featureapps.audi.com/audi-feature-app-footnote-engine/{{=SETUPS.get('nemo.FefaFeatureAppVersion')}}/audi-footnote-engine.theme.css"}]'></feature-app>
		{{??}}
			<audi-footnotes class="audi-footnotes sc-footnotes" data-module="footnotes">
				<ul class="audi-footnotes-list"></ul>
			</audi-footnotes>
		{{?}}
	{{?}}
`;
/* eslint-enable max-len */
export { exports as modalLayerFootnoteEngineTemplate };
